import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import FeedbackLanding from '../../../draws/FeedbackLanding';

export default function FeedbackRoutes() {
    return (
        <>
            <Route
                path='/feedback'
                element={
                    <RequireAdmin>
                        <FeedbackLanding />
                    </RequireAdmin>
                }
            />
        </>
    );
}
